"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const pako_1 = __importDefault(require("pako"));
const AxiosRetry = __importStar(require("axios-retry"));
const apiOrderToAppOrder_1 = __importDefault(require("../libs/apiOrderToAppOrder"));
const appBatchToApiBatch_1 = __importDefault(require("../libs/appBatchToApiBatch"));
const defaultTransformRequest = (_a = axios_1.default.defaults.transformRequest) !== null && _a !== void 0 ? _a : [];
const axiosRetry = AxiosRetry.default;
const retryConfig = {
    retries: 5,
    retryDelay: axiosRetry.exponentialDelay,
    shouldResetTimeout: true,
    retryCondition: (error) => {
        var _a, _b, _c, _d, _e, _f, _g;
        return AxiosRetry.isNetworkError(error) ||
            (error === null || error === void 0 ? void 0 : error.code) === 'ECONNABORTED' ||
            (((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 404 &&
                ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.error) === 'order not exist') ||
            ((_g = (_f = (_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.error) === null || _f === void 0 ? void 0 : _f.includes('broken pipe')) !== null && _g !== void 0 ? _g : false);
    },
};
function gzipTransform(api, data, headers) {
    headers['Content-Type'] = 'application/json;charset=UTF-8';
    headers['Accept-Language'] = api.locale;
    headers['X-App-Version'] = api.appVersion;
    try {
        if (typeof data === 'object') {
            const jsonString = JSON.stringify(data);
            // 資料小於 150 bytes 壓縮 gzip 反而會變大，因此先檢查大小再壓縮
            if (jsonString.length > 150) {
                const compressed = pako_1.default.gzip(jsonString);
                headers['Content-Encoding'] = 'gzip';
                return compressed;
            }
        }
    }
    catch (error) {
        console.error('transformRequest error', error);
    }
    return data;
}
class Api {
    constructor(baseUrlGo, baseUrlNode, configs = { locale: 'zh', appVersion: '' }) {
        this.gzip = true;
        this.appVersion = configs.appVersion;
        this.locale = configs.locale;
        this.baseUrlGo = baseUrlGo;
        this.baseUrlNode = baseUrlNode;
        this.axiosGo = axios_1.default.create({
            baseURL: baseUrlGo,
            timeout: 30000,
            transformRequest: [(data, headers) => {
                    return gzipTransform(this, data, headers);
                }].concat(defaultTransformRequest),
        });
        this.axiosNode = axios_1.default.create({
            baseURL: baseUrlNode,
            timeout: 30000,
            transformRequest: [(data, headers) => {
                    return gzipTransform(this, data, headers);
                }].concat(defaultTransformRequest),
        });
        axiosRetry(this.axiosGo, retryConfig);
        axiosRetry(this.axiosNode, retryConfig);
        this.apiVersion = '2.0.0';
        this.axiosGo.defaults.headers.common['X-Api-Version'] = this.apiVersion;
        this.axiosNode.defaults.headers.common['X-Api-Version'] = this.apiVersion;
    }
    setUrl(baseUrlGo, baseUrlNode) {
        this.axiosGo.defaults.baseURL = baseUrlGo;
        this.axiosNode.defaults.baseURL = baseUrlNode;
    }
    setApiTimeout(ms) {
        this.axiosGo.defaults.timeout = ms;
        this.axiosNode.defaults.timeout = ms;
    }
    setUpdateUserCallback(callback) {
        this.updateUserCallback = callback;
    }
    setResetUserCallback(callback) {
        this.resetUserCallback = callback;
    }
    setRefreshCustomerApiCallback(callback) {
        this.refreshCustomerApiCallback = callback;
    }
    setToken(token, refresh) {
        this.token = token;
        this.refresh = refresh;
        this.axiosGo.defaults.headers.common.Authorization = `Bearer ${token}`;
        this.axiosNode.defaults.headers.common.Authorization = `Bearer ${token}`;
    }
    setAppVersion(appVersion) {
        this.appVersion = appVersion;
    }
    setLanguage(locale) {
        this.locale = locale;
    }
    logError(error) {
        var _a, _b, _c, _d, _e, _f;
        if (((_a = error.response) === null || _a === void 0 ? void 0 : _a.data) != null && ((_b = error.response) === null || _b === void 0 ? void 0 : _b.status) != null) {
            console.error({
                type: 'ajax error',
                request: {
                    method: (_c = error.config) === null || _c === void 0 ? void 0 : _c.method,
                    url: (_d = error.config) === null || _d === void 0 ? void 0 : _d.url,
                    data: (_e = error.config) === null || _e === void 0 ? void 0 : _e.data,
                    params: (_f = error.config) === null || _f === void 0 ? void 0 : _f.params,
                },
                response: {
                    data: error.response.data,
                    status: error.response.status,
                },
            });
        }
        else {
            console.error(error);
        }
    }
    shortUrl(longUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (longUrl == null || longUrl === '') {
                throw new Error('argument not match');
            }
            const response = yield axios_1.default.post('https://s.dimorder.com/api/v1/shorten', { long_url: longUrl });
            return response.data.short_url;
        });
    }
    parseShortUrl(shortUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            if (shortUrl == null || shortUrl === '') {
                throw new Error('argument not match');
            }
            if (shortUrl.match(/https?:\/\/s\.dimorder\.com/) == null) {
                throw new Error('URL not match');
            }
            const response = yield fetch(shortUrl.replace('http://', 'https://'), {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            const data = yield response.json();
            if ((data === null || data === void 0 ? void 0 : data.route) == null || (data === null || data === void 0 ? void 0 : data.route) === '') {
                throw new Error('No result');
            }
            return data.route;
        });
    }
    getGlobalOrder(orderId, debug = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = `/g/order/${orderId}`;
            const params = {};
            if (debug) {
                params.debug = debug;
            }
            const response = yield this.axiosGo.get(endpoint, {
                params,
            });
            const apiOrder = response.data;
            const appOrder = (0, apiOrderToAppOrder_1.default)(apiOrder);
            return appOrder;
        });
    }
    calculateOrder(params) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = '/g/order';
            const { batches, deliveryType, shipping, rounding, surcharge, modifiers, promoCodeId, usedRiceCoin, from, taxes, isSurchargeBasedOnDiscountedItemTotal, isOrderProductModifierBasedOnDiscountedItemTotal, enableIntermediateRounding, } = params;
            const response = yield this.axiosGo.post(endpoint, {
                batches: batches.map((batch) => {
                    const apiBatch = (0, appBatchToApiBatch_1.default)({
                        orderId: '',
                        orderBatch: batch,
                        deliveryType: deliveryType,
                        shipping: shipping,
                        ignoreUnavailable: false,
                        preSubmit: false,
                        from: from,
                    });
                    apiBatch.status = 'submitted';
                    return apiBatch;
                }),
                taxes,
                deliveryType,
                shipping: deliveryType === 'storeDelivery' && shipping != null
                    ? Object.assign(Object.assign({}, shipping), { customerAmount: (_a = shipping.totalFee) !== null && _a !== void 0 ? _a : 0 }) : null,
                rounding,
                surcharge: deliveryType === 'table'
                    ? surcharge
                    : null,
                modifiers,
                promoCodeId: promoCodeId,
                riceCoin: usedRiceCoin,
                isSurchargeBasedOnDiscountedItemTotal,
                isOrderProductModifierBasedOnDiscountedItemTotal,
                enableIntermediateRounding,
            });
            const apiOrder = response.data;
            const appOrder = (0, apiOrderToAppOrder_1.default)(apiOrder);
            return appOrder;
        });
    }
}
exports.default = Api;
//# sourceMappingURL=Api.js.map